import { Button, Classes, Checkbox, Menu, Popover, PopoverInteractionKind, Radio, RadioGroup } from '@blueprintjs/core';
import { DatePicker } from "@blueprintjs/datetime";
import { POPOVER_DISMISS } from '@blueprintjs/core/lib/esm/common/classes';
import { formatForCalendar, formatDateInput } from "../../../utils/helpers";
import React from 'react';
import {
	clearButtonContainer, clientsFiltersContainer, displayFlex, filterButtonContainer, filterButtonMainDiv,
	filterModalMenu, filterPopoverSubtitle, levelsFiltersContainer, popoverSettings, serviceAreaButton, serviceLevelDiv, stateCheckbox,
	statesFiltersContainer, specialtyDiv, dateTimeDiv, specialtyFiltersContainer, dateTimeFiltersContainer, textAlignCenter, timeFilterInput,
	timeButtonsContainer,todayButtonStyle,clearDateTimeButtonStyle
} from '../../styles';
import { AppToaster } from "../../toastComponent";
import { ERROR_TOAST_ICON } from '../../../utils/Constants';

export const getFilters = (checkboxes) => {
	const selectedOptions = checkboxes.filter(option => option.isChecked);
	const values = selectedOptions.map(a => a.value);
	return values.join(',');
}

export const getSpecialtyFilter = (checkboxes, type) => {
	var selectedValue = checkboxes.find(option => option.isChecked && option.name === type)?.value;
	if (!selectedValue) {
		selectedValue = "";
	}
	return selectedValue;
}

export const getDateTimeFilter = (dateTimeValues, type) =>{
	var selectedDateTime = dateTimeValues.find(dateTime => dateTime.name === type);
	const defaultTime = selectedDateTime.name === "fromDateTime"? 'T00:00:00.000Z' : 'T23:59:59.000Z';
	const defaultSeconds= selectedDateTime.name === "fromDateTime"? ':00.000Z' : ':59.000Z';
	const selectedTime = selectedDateTime.time? "T"+selectedDateTime.time+defaultSeconds : defaultTime;
	const selectedDate = selectedDateTime.date;
	return selectedDate? selectedDate+selectedTime: null;
}

export default class FilterModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			serviceAreaCheckboxs: JSON.parse(JSON.stringify(this.props.fatherComponent.state.serviceAreaCheckboxs)),
			clientOptionsCheckboxs: JSON.parse(JSON.stringify(this.props.fatherComponent.state.clientOptionsCheckboxs)),
			levelOptionsCheckboxs: JSON.parse(JSON.stringify(this.props.fatherComponent.state.levelOptionsCheckboxs)),
			specialtyOptionsCheckboxs: JSON.parse(JSON.stringify(this.props.fatherComponent.state.specialtyOptionsCheckboxs)),
			fromToDateTimeValues: JSON.parse(JSON.stringify(this.props.fatherComponent.state.fromToDateTimeValues))
		}
	}

	state = {
		serviceAreaCheckboxs: [],
		clientOptionsCheckboxs: [],
		levelOptionsCheckboxs: [],
		specialtyOptionsCheckboxs: [],
		fromToDateTimeValues: []
	}

	handleFilterChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.type === 'checkbox' ? target.name : target.value;
		const filter = target.id;
		var filters = this.state[filter];

		if (target.type === 'radio') {
			filters.forEach(option => {
				if (option.name === name) {
					option.isChecked = !option.isChecked;
				} else {
					option.isChecked = false;
				}
			});
		} else {
			filters.forEach(option => {
				if (option.name === name) {
					option.isChecked = value
				}
			});
		}

		this.setState({ [filter]: filters });
		localStorage.setItem(`${filter}`, JSON.stringify(filters));
	}

	invalidDateTime = (fromToDateTimeValues) => {
		var fromDateTimeValue = getDateTimeFilter(fromToDateTimeValues, "fromDateTime");
		var toDateTimeValue = getDateTimeFilter(fromToDateTimeValues, "toDateTime");
		
		if (fromDateTimeValue && toDateTimeValue){
			const fromDateTime = new Date(fromDateTimeValue);
			const toDateTime = new Date (toDateTimeValue);
			return fromDateTime>toDateTime;
		}
		else{
			return false;
		}
	};

	handleDateChange = (date,name) => {
		var fromToDateTimeValues =JSON.parse(JSON.stringify(this.state.fromToDateTimeValues))

		if (date){
			fromToDateTimeValues.forEach( dateTime => {
				if (dateTime.name === name){
					dateTime.date = formatDateInput(date);
				}
			})
		}

		if(this.invalidDateTime(fromToDateTimeValues)){
			AppToaster.show({ message: "From Date/Time must be lower than To Date/Time", intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
			return;
		}	

		this.setState({ fromToDateTimeValues: fromToDateTimeValues });
		localStorage.setItem('fromToDateTimeValues', JSON.stringify(fromToDateTimeValues));
	}

	handleTimeChange = (e, name) => {
		var fromToDateTimeValues =JSON.parse(JSON.stringify(this.state.fromToDateTimeValues))
		const currentDateTime = fromToDateTimeValues.find(v => v.name === name);
		const currentTime = currentDateTime.time;

		if (currentDateTime.date === null) {
			AppToaster.show({ message: `In ${currentDateTime.label}: Date is required`, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
			e.currentTarget.value = currentTime;
			return;
		}

		const selectedTime = e.currentTarget.value;

		fromToDateTimeValues.forEach( dateTime => {
			if (dateTime.name === name){
				dateTime.time = selectedTime;
			}
		})

		if(this.invalidDateTime(fromToDateTimeValues)){
			AppToaster.show({ message: "From Date/Time must be lower than To Date/Time", intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
			e.currentTarget.value = currentTime;
			return;
		}

		this.setState({ fromToDateTimeValues: fromToDateTimeValues });
		localStorage.setItem('fromToDateTimeValues', JSON.stringify(fromToDateTimeValues));
	};

	setTimeInput = (name,value) =>{
		const timeInput = document.getElementById(name);
		timeInput.value = value;
	}

	setDefaultDateTime = (type) => {
		const initTime = "00:00";
		const finishTime= "23:59";
		const newDate = new Date();
		var fromToDateTimeValues = this.state.fromToDateTimeValues;

		if (type === 'tomorrow'){
			newDate.setDate(new Date().getDate()+1);
		}

		fromToDateTimeValues.forEach( dateTime => {
			dateTime.date = formatDateInput(newDate);
			dateTime.time = dateTime.name === 'fromDateTime'? initTime:finishTime;
			this.setTimeInput(dateTime.name,dateTime.time);
		})

		this.setState({ fromToDateTimeValues: fromToDateTimeValues });
		localStorage.setItem('fromToDateTimeValues', JSON.stringify(fromToDateTimeValues));
	};

	clearDateTime = (name) => {
		var fromToDateTimeValues = this.state.fromToDateTimeValues;

		fromToDateTimeValues.forEach( dateTime => {
			if(dateTime.name === name){
				dateTime.date = null;
				dateTime.time = null;
				this.setTimeInput(dateTime.name,null);
			}
		})

		this.setState({ fromToDateTimeValues: fromToDateTimeValues });
		localStorage.setItem('fromToDateTimeValues', JSON.stringify(fromToDateTimeValues));
	};

	handleClearSelectAll = (state) => {
		const serviceAreaCheckboxs = this.state.serviceAreaCheckboxs;
		const clientOptionsCheckboxs = this.state.clientOptionsCheckboxs;
		const levelOptionsCheckboxs = this.state.levelOptionsCheckboxs;
		const specialityOptionsRadio = this.state.specialtyOptionsCheckboxs

		serviceAreaCheckboxs.map(sa => sa.isChecked = state);
		clientOptionsCheckboxs.map(co => co.isChecked = state);
		levelOptionsCheckboxs.map(lo => lo.isChecked = state);

		if (!state) {
			specialityOptionsRadio.map(lo => lo.isChecked = state);
		}

		this.setState({
			serviceAreaCheckboxs: serviceAreaCheckboxs,
			clientOptionsCheckboxs: clientOptionsCheckboxs,
			levelOptionsCheckboxs: levelOptionsCheckboxs,
			specialtyOptionsCheckboxs: specialityOptionsRadio
		});

		localStorage.setItem('levelOptionsCheckboxs', JSON.stringify(levelOptionsCheckboxs));
		localStorage.setItem('serviceAreaCheckboxs', JSON.stringify(serviceAreaCheckboxs));
		localStorage.setItem('clientOptionsCheckboxs', JSON.stringify(clientOptionsCheckboxs));
		localStorage.setItem('specialtyOptionsCheckboxs', JSON.stringify(specialityOptionsRadio));
	}

	handleFilter = async () => {
		await this.props.fatherComponent.setState({
			serviceAreaCheckboxs: JSON.parse(JSON.stringify(this.state.serviceAreaCheckboxs)),
			clientOptionsCheckboxs: JSON.parse(JSON.stringify(this.state.clientOptionsCheckboxs)),
			levelOptionsCheckboxs: JSON.parse(JSON.stringify(this.state.levelOptionsCheckboxs)),
			specialtyOptionsCheckboxs: JSON.parse(JSON.stringify(this.state.specialtyOptionsCheckboxs)),
			fromToDateTimeValues: JSON.parse(JSON.stringify(this.state.fromToDateTimeValues))
		});
		
		this.props.fatherComponent.handleFilter();
	}

	render() {
		const minDate = new Date();
		minDate.setFullYear(minDate.getFullYear() - 5);

		const maxDate = new Date();
		maxDate.setFullYear(maxDate.getFullYear() + 5);

		return (
			<Popover position="bottom-left" style={popoverSettings} captureDismiss={true} isOpen={this.props.fatherComponent.state.isOpenFilter} onClose={this.props.fatherComponent.filterOnClick} canEscapeKeyClose={false} interactionKind={PopoverInteractionKind.CLICK} content={
				<Menu style={/*Hiding Datetime Inputs*/this.props.fatherComponent.state.isTripSearchContainer? {...filterModalMenu,width:"39em"}:filterModalMenu}>
					<div>
						<div style={displayFlex}>
							<div style={statesFiltersContainer}>
								<h4 style={filterPopoverSubtitle}>Service Area</h4>
								{this.state.serviceAreaCheckboxs.map(serviceArea => {
									return (
										<Checkbox
											id={'serviceAreaCheckboxs'}
											inline key={serviceArea.name}
											name={serviceArea.name}
											checked={serviceArea.isChecked}
											label={serviceArea.label}
											onChange={this.handleFilterChange}
											style={stateCheckbox}
										/>
									);
								})}
							</div>

							<div style={clientsFiltersContainer}>
								<h4 style={filterPopoverSubtitle}>Client</h4>
								{this.state.clientOptionsCheckboxs.map(clientOptions => {
									return (
										<Checkbox
											inline
											id="clientOptionsCheckboxs"
											key={clientOptions.name}
											name={clientOptions.name}
											checked={clientOptions.isChecked}
											label={clientOptions.label}
											onChange={this.handleFilterChange}
											style={stateCheckbox}
										/>
									);
								})}
							</div>

							<div style={serviceLevelDiv}>
								<div style={levelsFiltersContainer}>
									<h4 style={filterPopoverSubtitle}>Service Level</h4>
									{this.state.levelOptionsCheckboxs.map(levelOptions => {
										return (
											<Checkbox
												id="levelOptionsCheckboxs"
												inline key={levelOptions.name}
												name={levelOptions.name}
												checked={levelOptions.isChecked}
												label={levelOptions.label}
												onChange={this.handleFilterChange}
												style={stateCheckbox}
											/>
										);
									})}
								</div>
							</div>

							<div style={specialtyDiv}>
								<div style={specialtyFiltersContainer}>
									<h4 style={filterPopoverSubtitle}>Specialty</h4>
									<RadioGroup
										selectedValue={this.state.specialtyOptionsCheckboxs.find(option => option.isChecked)?.name}
										style={stateCheckbox}>
										{this.state.specialtyOptionsCheckboxs.map(specialty => {
											return (
												<Radio
													onClick={this.handleFilterChange}
													id="specialtyOptionsCheckboxs"
													key={specialty.name}
													value={specialty.name}
													label={specialty.label}
												/>
											);
										})}
									</RadioGroup>
								</div>
							</div>

							<div style={/*Hiding DateTime Inputs*/this.props.fatherComponent.state.isTripSearchContainer? {display: "none"}: dateTimeDiv}>
								{this.state.fromToDateTimeValues.map( value => {
									return(
										<div key = {value.name}>
											<h4 style={filterPopoverSubtitle}>{value.label}</h4>
											<div style={dateTimeFiltersContainer} className="md-form mx-2 my-2" >
												<Popover
													position={"bottom-left"}
													content={
														<DatePicker className={Classes.ELEVATION_1} 
															value={formatForCalendar(value.date)}
															onChange={(date) => this.handleDateChange(date,value.name)} highlightCurrentDay={true}
															minDate={minDate} maxDate = {maxDate}
														/>}
													target={<input style={textAlignCenter} className="form-control" size="10" 
														value={value.date? value.date : ''} readOnly />}
												>
												</Popover>
												<input style={timeFilterInput} type="time" id={value.name} className="form-control"
													defaultValue={value.time}
													onChange={(e) => this.handleTimeChange(e, value.name)} name={value.name}
												/>
												<Button style = {clearDateTimeButtonStyle} icon="small-cross" onClick={() => {this.clearDateTime(value.name)}}/>
											</div>
										</div>
									);
								})}
								<div style={timeButtonsContainer}>
									<Button style={todayButtonStyle} text="Today" onClick={() => {this.setDefaultDateTime('today')}} />
									<Button text="Tomorrow" onClick={() => {this.setDefaultDateTime('tomorrow')}}/>
								</div>
							</div>
						</div>
					</div>
					<div style={filterButtonMainDiv}>
						<div style={clearButtonContainer}>
							<Button
								text="Select all"
								icon="tick"
								onClick={() => this.handleClearSelectAll(true)}
								id={'isSelectAllFilters'}
								intent={'none'}
							/>
						</div>
						<div style={clearButtonContainer}>
							<Button
								text="Clear all"
								icon="cross"
								onClick={() => this.handleClearSelectAll(false)}
								id={'isClearAllFilters'}
								intent={'none'}
							/>
						</div>
						<div style={filterButtonContainer}>
							<Button
								text="Apply and Close"
								icon="filter"
								onClick={this.handleFilter}
								id={'isAllFilters'}
								className={POPOVER_DISMISS}
								intent={'primary'}
							/>
						</div>
					</div>
				</Menu>
			}>
				<Button style={serviceAreaButton} icon="chevron-down" text="Filters" onClick={() => { if (this.props.fatherComponent.filterOnClick) this.props.fatherComponent.filterOnClick() }} />
			</Popover>
		)
	}
}
